// removed by extract-text-webpack-plugin
module.exports = {"container":"src-ui-grid----grid-module---container---lP4Wm"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/grid/grid.module.scss
// module id = 322
// module chunks = 168707334958949